import { h, createContext } from 'preact';
import { useContext, useState } from 'preact/hooks';

const LocalizationContext = createContext(null);

export const useLocalizationContext = () => useContext(LocalizationContext);

export const LocalizationProvider = ({ children }) => {
  const [localization, setLocalization] = useState(null);

  return (
    <LocalizationContext.Provider value={{ localization, setLocalization }}>{children}</LocalizationContext.Provider>
  );
};

export default {
  LocalizationProvider,
  useLocalizationContext,
};
